// src/pages/SettingsPage/SettingsPage.jsx
import React, {useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import ThemeToggler from '../../components/Settings/ThemeToggler/ThemeToggler'; // Оставляем, если он не в SettingsListItem
import SettingsListItem from '../../components/Settings/SettingsListItem/SettingsListItem'; // <--- Импорт
import styles from './SettingsPage.module.css';
import { FormattedMessage, useIntl } from 'react-intl';
import {FiSun, FiMoon, FiGlobe, FiMessageSquare, FiEdit3, FiShield, FiFileText, FiHelpCircle} from 'react-icons/fi'; // Иконки для настроек
import { ThemeContext } from '../../contexts/ThemeContext';
import {useAuth} from "../../contexts/AuthContext";
import Title from "../../components/common/Title/Title";
import {hideBackButton} from "../../services/telegramService"; // Для отображения текущей темы

const SettingsPage = () => {
    const { user } = useAuth();
    const { theme } = React.useContext(ThemeContext); // Получаем текущую тему
    const intl = useIntl();
    const navigate = useNavigate();

    useEffect(() => {
        hideBackButton();
    }, []);

    const currentLanguageName = intl.formatMessage({ id: `settings.selectLanguage.${user.lang}` });

    return (
        <div className={styles.pageWrapper}>
            <Title><FormattedMessage id="settings.pageTitle"/></Title>

            {/*<div className={styles.settingsGroup}>*/}
            {/*    <h2 className={styles.groupTitle}>*/}
            {/*        <FormattedMessage id="settings.appearanceGroupTitle"/>*/}
            {/*    </h2>*/}
            {/*    <div className={styles.settingsList}> /!* Обертка для элементов списка *!/*/}
            {/*        <SettingsListItem*/}
            {/*            icon={theme === 'light' ? FiMoon : FiSun} // Иконка меняется в зависимости от темы*/}
            {/*            title={intl.formatMessage({id: "settings.darkModeLabel"})}*/}
            {/*        >*/}
            {/*            <ThemeToggler/> /!* ThemeToggler теперь внутри SettingsListItem *!/*/}
            {/*        </SettingsListItem>*/}
            {/*    </div>*/}
            {/*</div>*/}

            <div className={styles.settingsGroup}>
                <h2 className={styles.groupTitle}>
                    <FormattedMessage id="settings.general"/>
                </h2>
                <div className={styles.settingsList}>
                    <SettingsListItem
                        icon={FiGlobe}
                        title={intl.formatMessage({id: "settings.changeLanguageButton"})}
                        currentValue={currentLanguageName}
                        to="/settings/language" // Используем to для навигации
                    />
                </div>
            </div>

            <div className={styles.settingsGroup}>
                <h2 className={styles.groupTitle}>
                    <FormattedMessage id="settings.helpGroupTitle"/>
                </h2>
                <div className={styles.settingsList}>
                    <SettingsListItem
                        icon={FiHelpCircle}
                        title={intl.formatMessage({id: "settings.faqButton", defaultMessage: "Вопросы и ответы (FAQ)"})}
                        to="/faq"
                    />
                    <SettingsListItem
                        icon={FiEdit3} // FiMessageSquare или FiEdit3
                        title={intl.formatMessage({id: "settings.suggestIdeaButton"})}
                        to="/settings/suggest-idea"
                    />
                </div>
            </div>

            <div className={styles.settingsGroup}>
                <h2 className={styles.groupTitle}>
                    <FormattedMessage id="settings.legalGroupTitle"/>
                </h2>
                <div className={styles.settingsList}>
                    <SettingsListItem
                        icon={FiShield}
                        title={intl.formatMessage({id: "settings.privacyPolicyButton"})}
                        to="/privacy-policy"
                    />
                    <SettingsListItem
                        icon={FiFileText}
                        title={intl.formatMessage({id: "settings.termsOfUseButton"})}
                        to="/terms-of-use"
                    />
                </div>
            </div>

        </div>
    );
};

export default SettingsPage;
